<template>
  <div class="rental-card-wide col-lg-12 col-md-12">
    <div :class="`boxed-widget--clean boxed-widget--mobile animate ${rental.hasWatermarkedImages && !this.$store.state.userIsPremium ? 'rental-watermark-disable-hover' : ''}`">
      <div v-if="rental.status !== houseStatuses.rented_out">
         <adivare-favourite-btn-star
            v-if="!rental.isBlurred"
            :rental-id="rental.id"
            :rental-short-id="rental.shortId"
            class="listing-like-top"
        ></adivare-favourite-btn-star>
        <adivare-list-item-content
            :rental="rental"
            :index="index"
        ></adivare-list-item-content>
      </div>
      <div v-else>
        <adivare-newsletter-subscribe-wrapper
          :rentalShortId="rental.shortId"
        >
          <i class="far fa-bell"></i>
          <adivare-list-item-content
              :rental="rental"
              :index="index"
          ></adivare-list-item-content>
        </adivare-newsletter-subscribe-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import AdivareFavouriteBtnStar from "../../favourite-btn-star";
import AdivareListItemContent from "./list-item-content";
import AdivareNewsletterSubscribeWrapper from "../../newsletter-subscribe-wrapper";
import sharedJS from '../../../../../common/vue/components-js/list-item-wrapper.js';

export default {
  components: {
    AdivareNewsletterSubscribeWrapper,
    AdivareFavouriteBtnStar,
    AdivareListItemContent,
  },
  extends: sharedJS,
}
</script>
